document.addEventListener('DOMContentLoaded', function () {
  var body = document.body;
  var wishlistToggleBtns = document.querySelectorAll('[data-wishlist-toggle]');
  var wishlistCloseBtn = document.querySelector('[data-wishlist-close]');
  var wishlistOverlay = document.querySelector('[data-wishlist-overlay]');
  var wishlistItemsWrapper = document.querySelector('[data-wishlist-items]');
  var wishlistCountBadges = document.querySelectorAll('[data-wishlist-count]');
  var wishlistDrawer = document.querySelector('[data-wishlist-drawer]');
  var emptyText = wishlistDrawer ? wishlistDrawer.getAttribute('data-empty-text') : '';
  var removeLabel = wishlistDrawer ? wishlistDrawer.getAttribute('data-remove-label') : '';
  var storageKey = 'habitat_wishlist';

  function openWishlist() {
    body.classList.add('wishlist-open');
  }

  function closeWishlist() {
    body.classList.remove('wishlist-open');
  }

  wishlistToggleBtns.forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      openWishlist();
    });
  });

  if (wishlistCloseBtn) {
    wishlistCloseBtn.addEventListener('click', closeWishlist);
  }

  if (wishlistOverlay) {
    wishlistOverlay.addEventListener('click', closeWishlist);
  }

  function getWishlist() {
    var raw = localStorage.getItem(storageKey);
    if (!raw) {
      return [];
    }
    return JSON.parse(raw);
  }

  function saveWishlist(list) {
    localStorage.setItem(storageKey, JSON.stringify(list));
  }

  function formatMoney(amount) {
    return '€' + parseFloat(amount).toFixed(2);
  }

  function renderWishlist() {
    var list = getWishlist();

    wishlistCountBadges.forEach(function (badge) {
      badge.textContent = list.length;
    });

    if (list.length === 0) {
      wishlistItemsWrapper.innerHTML = '<p class="wishlist-drawer__empty">' + emptyText + '</p>';
      return;
    }

    var html = '';
    list.forEach(function (product) {
      html += '<div class="wishlist-item" data-wishlist-id="' + product.id + '">';
      html += '<img src="' + product.image + '" alt="' + product.title + '" class="wishlist-item__image" width="60" height="60">';
      html += '<div>';
      html += '<p class="wishlist-item__title">' + product.title + '</p>';
      html += '<span class="wishlist-item__price">' + formatMoney(product.price) + '</span>';
      html += '</div>';
      html += '<button type="button" class="wishlist-item__remove" data-wishlist-remove="' + product.id + '" aria-label="' + removeLabel + '">&times;</button>';
      html += '</div>';
    });

    wishlistItemsWrapper.innerHTML = html;
    bindRemoveEvents();
  }

  function bindRemoveEvents() {
    var removeBtns = wishlistItemsWrapper.querySelectorAll('[data-wishlist-remove]');
    removeBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var id = btn.getAttribute('data-wishlist-remove');
        var list = getWishlist().filter(function (product) {
          return String(product.id) !== id;
        });
        saveWishlist(list);
        renderWishlist();
      });
    });
  }

  function addToWishlist(product) {
    var list = getWishlist();
    var alreadyThere = list.some(function (item) {
      return String(item.id) === String(product.id);
    });

    if (alreadyThere) {
      return;
    }

    list.push(product);
    saveWishlist(list);
    renderWishlist();
    openWishlist();
  }

  document.addEventListener('product:toggle-wishlist', function (e) {
    addToWishlist(e.detail);
  });

  renderWishlist();
});